import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const SITE_URL = 'https://zitie.mintool.app'

const ROUTE_KEYS: Record<string, 'home' | 'help' | 'terms' | 'privacy'> = {
  '/': 'home',
  '/help': 'help',
  '/terms': 'terms',
  '/privacy': 'privacy',
}

const HTML_LANG: Record<string, string> = {
  en: 'en',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
}

function getCanonicalUrl(pathname: string): string {
  if (pathname === '/') return `${SITE_URL}/`
  return `${SITE_URL}${pathname}`
}

function updateMetaByName(name: string, content: string): void {
  let element = document.querySelector(`meta[name="${name}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute('name', name)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function updateMetaByProperty(property: string, content: string): void {
  let element = document.querySelector(`meta[property="${property}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute('property', property)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function updateCanonical(href: string): void {
  let element = document.querySelector('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

const Seo: React.FC = () => {
  const location = useLocation()
  const { i18n, t } = useTranslation()

  useEffect(() => {
    const routeKey = ROUTE_KEYS[location.pathname] ?? 'home'
    const title = t(`seo.routes.${routeKey}.title`)
    const description = t(`seo.routes.${routeKey}.description`)
    const canonicalUrl = getCanonicalUrl(location.pathname)
    const htmlLang = HTML_LANG[i18n.resolvedLanguage || i18n.language] ?? 'en'

    document.documentElement.lang = htmlLang
    document.title = title
    updateMetaByName('description', description)
    updateCanonical(canonicalUrl)

    updateMetaByProperty('og:title', title)
    updateMetaByProperty('og:description', description)
    updateMetaByProperty('og:url', canonicalUrl)
    updateMetaByProperty('og:site_name', t('seo.siteName'))

    updateMetaByName('twitter:title', title)
    updateMetaByName('twitter:description', description)
  }, [i18n.language, i18n.resolvedLanguage, location.pathname, t])

  return null
}

export default Seo
